/**
 * Live countdown for the end of the currently active special price.
 *
 * The markup is rendered server side as
 *   <span class="special-price-countdown" data-countdown-end="<unix ts>"
 *         data-countdown-label="Angebot endet in"
 *         data-countdown-days="Tage"></span>
 * and this scope function fills in the remaining time. The server decides
 * which special price is active (and therefore the end timestamp), so this
 * only has to count down to that fixed moment.
 */

import './countdown.css';

function formatRemaining(ms, daysLabel) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  const clock = pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
  if (days <= 0) {
    return clock;
  }
  return days + " " + (daysLabel || "d") + " " + clock;
}

function setUpSpecialPriceCountdown(scope) {
  const elements = Array.from(scope.querySelectorAll("[data-countdown-end]"));
  elements.forEach((element) => {
    if (element.dataset.countdownInitialized === "y") {
      return;
    }
    element.dataset.countdownInitialized = "y";

    const end = parseInt(element.dataset.countdownEnd, 10);
    const label = element.dataset.countdownLabel ?? "";
    const daysLabel = element.dataset.countdownDays ?? "";
    if (!end) {
      return;
    }

    const render = () => {
      const remaining = end * 1000 - Date.now();
      if (remaining <= 0) {
        element.textContent = "";
        return false;
      }
      const time = formatRemaining(remaining, daysLabel);
      element.textContent = label ? label + " " + time : time;
      return true;
    };

    render();
    const timer = setInterval(() => {
      if (!render()) {
        clearInterval(timer);
      }
    }, 1000);
  });
}

export {setUpSpecialPriceCountdown};
